// SFB-1321: a partner only manages two logos, `responsiveLogoUrl` (compact) and
// `fullLogoUrl` (wide). Every touchpoint picks one through these helpers so the
// fallback is the same everywhere: the other managed logo first, then the legacy
// `partnerBrand` images, then ''. Callers render their own placeholder on ''.

const firstUrl = (...urls) => urls.find(url => typeof url === 'string' && url.trim()) || ''

// Compact spaces: sidebars, avatars, sponsor chips, favicon.
export function getResponsiveLogo(partner) {
  const brand = partner?.partnerBrand
  return firstUrl(partner?.responsiveLogoUrl, partner?.fullLogoUrl, brand?.responsiveLogo, brand?.fullLogo)
}

// Wide spaces: headers, welcome and onboarding screens.
export function getFullLogo(partner) {
  const brand = partner?.partnerBrand
  return firstUrl(partner?.fullLogoUrl, partner?.responsiveLogoUrl, brand?.fullLogo, brand?.responsiveLogo)
}
